let cvdCountdownStarted = false;
let cvdUpdateTimeout = null;
let cvdFetching = false;
let cvdPendingUpdate = false;
let cvdIgnoreMutation = false;

function updateCVD() {
  if (cvdFetching) {
    cvdPendingUpdate = true;
    return;
  }
  cvdFetching = true;
  cvdPendingUpdate = false;

  fetch('/cart.js', { cache: 'no-store' })
    .then(r => r.json())
    .then(cart => {
      const qty = cart.item_count;

      if (qty === 0) {
        localStorage.removeItem('cvdCountdownEnd');
        cvdCountdownStarted = false;
      }

      document.querySelectorAll('.cvd-step').forEach(el => {
        el.classList.toggle('is-active', qty >= parseInt(el.dataset.min));
      });

      let pct = 0;
      if (qty >= 4) pct = 100;
      else if (qty >= 3) pct = 66;
      else if (qty >= 2) pct = 33;
      else if (qty === 1) pct = 8;

      document.querySelectorAll('#cvd-bar, .cvd-track-fill').forEach(bar => {
        bar.style.width = pct + '%';
      });

      let html = '';
      if (qty >= 4) html = '🎉 Vous bénéficiez de <strong>-20&nbsp;%</strong> !';
      else if (qty >= 3) html = 'Ajoutez 1 article de plus pour <strong>-20&nbsp;%</strong>';
      else if (qty >= 2) html = 'Ajoutez 1 article de plus pour <strong>-15&nbsp;%</strong>';
      else html = 'Ajoutez 1 article de plus pour <strong>-10&nbsp;%</strong>';

      document.querySelectorAll('#cvd-message, .cvd-message').forEach(m => {
        m.innerHTML = html;
      });

      let tagText = '';
      if (qty >= 4) tagText = '4 articles – 20%';
      else if (qty >= 3) tagText = '3 articles – 15%';
      else if (qty >= 2) tagText = '2 articles – 10%';

      document.querySelectorAll('.cvd-item-tag').forEach(tag => {
        const textEl = tag.querySelector('.cvd-item-tag-text');
        if (tagText) {
          tag.style.display = 'flex';
          if (textEl) textEl.textContent = tagText;
        } else {
          tag.style.display = 'none';
        }
      });

      renderCVDCountdown();
    })
    .catch(() => {})
    .finally(() => {
      cvdFetching = false;
      if (cvdPendingUpdate) setTimeout(updateCVD, 300);
    });
}

function debouncedUpdateCVD() {
  if (cvdUpdateTimeout) clearTimeout(cvdUpdateTimeout);
  cvdUpdateTimeout = setTimeout(updateCVD, 300);
}

function getCVDCountdownEnd() {
  const stored = localStorage.getItem('cvdCountdownEnd');
  if (stored) {
    const end = parseInt(stored, 10);
    if (!isNaN(end) && end > Date.now()) return end;
  }
  return null;
}

function setCVDCountdownEnd(seconds) {
  const end = Date.now() + seconds * 1000;
  localStorage.setItem('cvdCountdownEnd', String(end));
  return end;
}

function renderCVDCountdown() {
  const els = document.querySelectorAll('#cvd-countdown');
  if (!els.length) return;
  const end = getCVDCountdownEnd();
  if (!end) return;
  const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
  const text = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
  els.forEach(el => { el.textContent = text; });
}

function startCVDCountdown(seconds) {
  let end = getCVDCountdownEnd();
  if (!end) end = setCVDCountdownEnd(seconds);
  renderCVDCountdown();
  if (cvdCountdownStarted) return;
  cvdCountdownStarted = true;
  setInterval(renderCVDCountdown, 1000);
}

const drawerObserver = new MutationObserver(() => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && drawer.classList.contains('active')) {
    startCVDCountdown(600);
  }
});

const drawer = document.querySelector('cart-drawer');
if (drawer) {
  drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('cart:updated', debouncedUpdateCVD);

document.addEventListener('click', (event) => {
  const cartScope = event.target.closest('#CartDrawer-CartItems, #main-cart-items');
  const addToCartBtn = event.target.closest('button[name="add"]');

  if (!cartScope && !addToCartBtn) return;

  const minusBtn = event.target.closest('.quantity__button[name="minus"]');
  const plusBtn = event.target.closest('.quantity__button[name="plus"]');
  const removeBtn = event.target.closest('cart-remove-button');

  if (minusBtn || plusBtn || removeBtn || addToCartBtn) {
    cvdIgnoreMutation = true;
    if (cvdUpdateTimeout) clearTimeout(cvdUpdateTimeout);
    cvdUpdateTimeout = setTimeout(() => {
      cvdIgnoreMutation = false;
      updateCVD();
    }, 500);
  }
}, true);

document.addEventListener('change', (event) => {
  if (event.target.matches('.quantity__input')) {
    debouncedUpdateCVD();
  }
});

// menos com quantidade 1: remove o artigo do carrinho
document.addEventListener(
  'click',
  (event) => {
    const minus = event.target.closest('#CartDrawer-CartItems .quantity__button[name="minus"]');
    if (!minus) return;

    const input = minus.parentElement.querySelector('.quantity__input');
    if (!input || parseInt(input.value, 10) > 1) return;

    const item = minus.closest('.cvd-item');
    const removeBtn = item && item.querySelector('cart-remove-button button, cart-remove-button a');
    if (!removeBtn) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    removeBtn.click();
  },
  true
);
